import React from 'react'
import {connect} from 'react-redux'
import styles from './ShowPage.scss'
import {ReportViewer} from './ReportViewer'
import appStyles from '../App/appStyles.scss'
import cx from 'classnames'
import {Masthead} from './Masthead'
import * as actions from '../App/actions'
import {Nav} from './Nav'
import {Navbar, NavbarGroup} from 'common/Navbar'
import {CommentsContainer} from 'common/Comments'
import * as reportActions from 'lib/api/rideReports'
import * as followActions from 'lib/api/usersFollowed'
import {CircleSpinner} from 'common/spinners'
import {Footer} from './Footer'
import {keyIn} from 'lib/utils'
import * as tripActions from 'lib/api/trips'
import Helmet from 'react-helmet'
import {SocialButtons} from './SocialButtons'
import {GlobalFooter} from 'common/GlobalFooter'

export class ShowPage extends React.Component {
  componentDidMount () {
    // should consider a way to share this logic with EditPage
    const {report, loadReport, reportId, loadUserReports} = this.props

    if (!report) {
      loadReport(reportId).then(result => {
        const report = this.props.report
        loadUserReports(report.user.id)
        // ensureRidesLoaded will execute as an effect of componentDidUpdate
      })
    } else {
      loadUserReports(report.user.id)
      this.ensureRidesLoaded()
    }
  }

  componentDidUpdate (prevProps) {
    const prevReport = prevProps.report
    const {report} = this.props

    if ((prevReport && prevReport.id) !== (report && report.id)) {
      this.ensureRidesLoaded()
    }
  }

  ensureRidesLoaded = () => {
    const {rides, loadRide, report} = this.props
    const rideIds = report.rides
    rideIds.forEach(id => {
      // TODO: we need to track pending ride loads in the reducer here, but
      // that's going to impact every bit of code that assumes the presence
      // of a rideId in the record Map implies that it's loaded.
      if (!rides.get(id)) { loadRide(id) }
    })
  }

  onIsFollowingChange = (isFollowing) => {
    const {report, followUser, unfollowUser} = this.props
    ;(isFollowing ? followUser : unfollowUser)(report.user.id)
  }

  handleHeartClick = () => {
    const {report, likeReport, unlikeReport} = this.props
    if (report.likedByCurrentUser) {
      unlikeReport(report.id)
    } else {
      likeReport(report.id)
    }
  }

  render () {
    const {report, rides, currentUser, relatedReports, usersFollowed, journalArticle, newsArticle, OverwriteNav} = this.props

    // FIXME when we have a published_at date in the schema, use that instead of
    // the created at date for this header
    if (!report) {
      return <div className={cx(styles.ShowPage, appStyles.base)}>
        <Navbar>
          <NavbarGroup>
            <li>Loading {(journalArticle || newsArticle) ? 'article' : 'ride report'}...</li>
          </NavbarGroup>
        </Navbar>
        <div className={styles.loadingSpinner}>
          <CircleSpinner size={50} />
        </div>
      </div>
    }
    const canEdit = report.user.id === currentUser.id
    const liked = report.likedByCurrentUser

    return (
      <div className={cx(styles.ShowPage, appStyles.base)}>
        <Helmet title={report.title} />
        {OverwriteNav || <Nav
          author={journalArticle ? report.authorByline : report.user}
          rides={report.rides}
          reportSlug={report.slug}
          contestEntry={report.contestEntry}
          canEdit={canEdit}
          publishedAt={report.createdAt}
          currentUser={currentUser}
          isFollowing={usersFollowed.get(report.user.id)}
          onIsFollowingChange={this.onIsFollowingChange} />}
        <div className={styles.reportContainer}>
          <Masthead
            title={report.title}
            subtitle={report.subtitle}
            liked={liked} likesCount={report.likesCount} onHeartClick={this.handleHeartClick}
          />
          <ReportViewer report={report} rides={rides} />
        </div>
        <hr />
        <SocialButtons liked={liked} likesCount={report.likesCount} onHeartClick={this.handleHeartClick} />
        <div className={styles.commentsContainer}>
          <CommentsContainer
            objectType='ride_report'
            objectId={report.id}
            currentUser={currentUser}
            canModerate={currentUser.id === report.user.id} />
        </div>
        <Footer report={report} relatedReports={relatedReports} journalArticle={journalArticle} newsArticle={newsArticle} />
        <GlobalFooter className={styles.report} />
      </div>
    )
  }
}
const compareDates = (a, b) => {
  const dateA = new Date(a.updatedAt)
  const dateB = new Date(b.updatedAt)
  return dateB.getTime() - dateA.getTime()
}

const mapStateToProps = (state, ownProps) => {
  const slug = ownProps.params.slug
  const reportId = parseInt(slug, 10) || ownProps.reportId
  const report = state.rideReports.reports.get(reportId)
  const usersFollowed = state.usersFollowed
  const rides = report ? state.trips.filter(keyIn(report.rides)) : []
  const userTopic = report && state.rideReports.topics.get(`user/${report.user.id}`)
  return {
    rides,
    report,
    reportId,
    usersFollowed,
    currentUser: state.currentUser,
    relatedReports: userTopic && userTopic.reportIds
      .map(id => state.rideReports.reports.get(id))
      .filter(r => r.publishStatus !== 'draft')
      .filter(r => r.id !== reportId)
      .sort(compareDates).take(4)
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadReport: (reportId) => dispatch(reportActions.loadReport(reportId)),
  receiveRides: (rides) => dispatch(actions.receiveRides(rides)),
  loadUserReports: id => dispatch(reportActions.loadUserReports(id)),
  loadRide: (id) => dispatch(tripActions.loadTrip(id)),
  followUser: (userId) => dispatch(followActions.followUser(userId)),
  unfollowUser: (userId) => dispatch(followActions.unfollowUser(userId)),
  likeReport: (reportId) => dispatch(reportActions.likeReport(reportId)),
  unlikeReport: (reportId) => dispatch(reportActions.unlikeReport(reportId))
})

export const ShowPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ShowPage)
